import { objectKeysToCamelCase } from '@heidi-pay/heidi-common-fe/utils/objectKeysToCamelCase';
import { styled } from '@mui/material';
import { StatusIcon } from '@components/StatusIcon';
import { StatusIconType } from '@components/StatusIcon/enums';
import { IMerchantPortalOrderApplicationDetails } from '@schemas/merchantPortal/types/orderApplicationDetails';

export const getRequiredDocumentsCount = (
  orderApplicationDetailsData: IMerchantPortalOrderApplicationDetails,
) => {
  if (!orderApplicationDetailsData) {
    return 0;
  }

  const { customerAgreementSigningOverview, manualIdentityUploadSummary } =
    objectKeysToCamelCase(orderApplicationDetailsData);

  const documentsNeedToBeUploaded =
    customerAgreementSigningOverview.isManualSigningRequired &&
    !customerAgreementSigningOverview.hasUploadedSignedAgreement;

  const manualIdentityUploadRequired =
    manualIdentityUploadSummary.isManualIdentityDocumentUploadRequired &&
    !manualIdentityUploadSummary.hasIdentityDocumentBeenUploaded;

  return [documentsNeedToBeUploaded, manualIdentityUploadRequired].filter(
    Boolean,
  ).length;
};

const StyledStatusIcon = styled(StatusIcon)({
  marginLeft: '5px',
  marginRight: '5px',
  position: 'relative',
});

interface ICustomerDocumentsTabIcon {
  orderApplicationDetailsData:
    | IMerchantPortalOrderApplicationDetails
    | undefined;
}

export const CustomerDocumentsTabIcon = ({
  orderApplicationDetailsData,
}: ICustomerDocumentsTabIcon) => {
  if (!orderApplicationDetailsData) {
    return null;
  }

  const countRequired = getRequiredDocumentsCount(orderApplicationDetailsData);

  return countRequired > 0 ? (
    <>
      <StyledStatusIcon type={StatusIconType.Error} /> ( {countRequired} )
    </>
  ) : null;
};
